var _path, _path2, _mask, _path3, _mask2, _path4, _path5, _path6, _path7, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoBanner2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 19C42 9.05887 33.9411 1 24 1C14.0589 1 6 9.05887 6 19",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9758 29.9999C38.827 36.0792 33.5051 40.6596 27 41.751",
    stroke: "white",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_9_3599",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.62331 18.032C7.46646 18.119 8 18.9081 8 19.7558V28.2442C8 29.0919 7.46646 29.881 6.62331 29.968C6.41842 29.9892 6.21048 30 6 30C2.68629 30 0 27.3137 0 24C0 20.6863 2.68629 18 6 18C6.21048 18 6.41842 18.0108 6.62331 18.032Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62331 18.032L6.41797 20.0214L6.62331 18.032ZM10 28.2442V19.7558H6V28.2442H10ZM6.41797 27.9786C6.28118 27.9927 6.14178 28 6 28V32C6.27918 32 6.55566 31.9856 6.82865 31.9574L6.41797 27.9786ZM6 28C3.79086 28 2 26.2091 2 24H-2C-2 28.4183 1.58172 32 6 32V28ZM2 24C2 21.7909 3.79086 20 6 20V16C1.58172 16 -2 19.5817 -2 24H2ZM6 20C6.14178 20 6.28118 20.0073 6.41797 20.0214L6.82865 16.0426C6.55566 16.0144 6.27918 16 6 16V20ZM10 19.7558C10 18.1984 8.97721 16.2643 6.82865 16.0426L6.41797 20.0214C6.33715 20.0131 6.25264 19.9855 6.17786 19.9414C6.10606 19.899 6.06079 19.8521 6.03564 19.819C5.99159 19.761 6 19.7379 6 19.7558H10ZM6 28.2442C6 28.2621 5.99159 28.239 6.03564 28.181C6.06079 28.1479 6.10606 28.101 6.17786 28.0586C6.25264 28.0145 6.33715 27.9869 6.41797 27.9786L6.82865 31.9574C8.9772 31.7357 10 29.8016 10 28.2442H6Z",
    fill: "white",
    mask: "url(#path-3-inside-1_9_3599)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_9_3599",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3767 18.032C40.5335 18.119 40 18.9081 40 19.7558V28.2442C40 29.0919 40.5335 29.881 41.3767 29.968C41.5816 29.9892 41.7895 30 42 30C45.3137 30 48 27.3137 48 24C48 20.6863 45.3137 18 42 18C41.7895 18 41.5816 18.0108 41.3767 18.032Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3767 18.032L41.582 20.0214L41.3767 18.032ZM38 28.2442V19.7558H42V28.2442H38ZM41.582 27.9786C41.7188 27.9927 41.8582 28 42 28V32C41.7208 32 41.4443 31.9856 41.1713 31.9574L41.582 27.9786ZM42 28C44.2091 28 46 26.2091 46 24H50C50 28.4183 46.4183 32 42 32V28ZM46 24C46 21.7909 44.2091 20 42 20V16C46.4183 16 50 19.5817 50 24H46ZM42 20C41.8582 20 41.7188 20.0073 41.582 20.0214L41.1713 16.0426C41.4443 16.0144 41.7208 16 42 16V20ZM38 19.7558C38 18.1984 39.0228 16.2643 41.1713 16.0426L41.582 20.0214C41.6628 20.0131 41.7474 19.9855 41.8221 19.9414C41.8939 19.899 41.9392 19.8521 41.9644 19.819C42.0084 19.761 42 19.7379 42 19.7558H38ZM42 28.2442C42 28.2621 42.0084 28.239 41.9644 28.181C41.9392 28.1479 41.8939 28.101 41.8221 28.0586C41.7474 28.0145 41.6628 27.9869 41.582 27.9786L41.1713 31.9574C39.0228 31.7357 38 29.8016 38 28.2442H42Z",
    fill: "white",
    mask: "url(#path-5-inside-2_9_3599)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27 42C27 43.4602 25.4289 45 23 45C20.5711 45 19 43.4602 19 42C19 40.5398 20.5711 39 23 39C25.4289 39 27 40.5398 27 42Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0526 17L24.6705 9.84091V9.78125H20.456V8.27273H26.5795V9.80256L22.9574 17H21.0526Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0526 31L24.6705 23.8409V23.7812H20.456V22.2727H26.5795V23.8026L22.9574 31H21.0526Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 19,
    width: 20,
    height: 2,
    rx: 1,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBanner2);
export default __webpack_public_path__ + "static/media/info-banner-2.3719cf29f943d3b920a9097cd70510e5.svg";
export { ForwardRef as ReactComponent };